import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  flex-direction: column;
  gap: 1rem;
`;

const LoadingScreen = () => {
  return (
    <Container>
      <l-line-spinner size="40" stroke="3" speed="1" color="var(--bg-plava)" />
    </Container>
  );
};
export default LoadingScreen;
